import { MenuList, MenuItem } from '@mui/material';
import styled from 'styled-components';
import {
  compose,
  space,
  SpaceProps,
  layout,
  LayoutProps,
  typography,
  TypographyProps,
  shadow,
  ShadowProps,
  position,
  PositionProps,
  FlexboxProps,
  color,
  ColorProps,
  DisplayProps,
  border,
  BordersProps,
  zIndex,
  ZIndexProps
} from 'styled-system';

/**
 * Popover placement options relative to its children
 */
export type Placement =
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export type StyledMenuProps = ColorProps &
  SpaceProps &
  TypographyProps &
  ShadowProps &
  DisplayProps &
  BordersProps &
  FlexboxProps &
  ZIndexProps &
  PositionProps &
  LayoutProps & {
    keyboardMode?: boolean;
  };

interface PopoverMenuItemProps {
  /**
   * Whether the popover menu component should stretch the full width of its container
   */
  fullWidth?: boolean;
}
export interface IContainerProps {
  /**
   * Whether the popover menu component should stretch the full width of its container
   */
  fullWidth?: boolean;
}

/**
 * PopoverMenu style configuration
 */
const config = {
  WIDTH: 205,
  MAX_HEIGHT: 192,
  MARGIN: 8,
  FULL_WIDTH: '100%'
};

/**
 * Container for children of `PopoverMenu`
 */
export const ChildrenContainer = styled.div<{ disabled?: boolean }>`
  display: inline-block;
  cursor: pointer;
  -webkit-appearance: none;

  ${({ disabled }) => disabled && 'cursor: not-allowed;'}
`;

/**
 * Wrapper for list of menu options
 */
export const Menu = styled(MenuList)<StyledMenuProps & IContainerProps>`
  width: ${({ fullWidth }) =>
    fullWidth ? config.FULL_WIDTH : `${config.WIDTH}px`};
  max-height: ${config.MAX_HEIGHT}px;
  background-color: ${({ theme }) => theme.uptimeColors.grayScales.white};
  overflow: auto;

  ${compose(space, color, layout, shadow, zIndex, position)}
`;

/**
 * Menu list item
 */
export const Item = styled(MenuItem)<StyledMenuProps & PopoverMenuItemProps>`
  width: ${({ fullWidth }) =>
    fullWidth ? config.FULL_WIDTH : `${config.WIDTH}px`};
  list-style: none;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;

  ${compose(typography, space, color, layout, border, layout)}
`;

// Wrapper for menu list label text
export const TextWrapper = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/**
 * Icon wrapper for menu list item
 */
export const IconWrapper = styled.div`
  margin-right: 10px;
  & > svg {
    display: inline-block;
    vertical-align: middle;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }
`;
